import * as React from 'react';

const LogoIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="79"
    height="66"
    fill="none"
    viewBox="0 0 79 66"
    {...props}
  >
    <path
      fill={props?.fill ?? '#1B2846'}
      d="m78.957 20.29-.487-.5c-2.568.662-7.219 1.56-12.949 1.398l-.44.426c1.109 2.56 2.568 7.96-2.797 11.418-4.65 3.458-10.062 3.12-14.135-.897-5.943-5.871-8.541-15.39-5.152-18.863 1.413-1.501 3.161-2.296 4.514-2.708v-.588C43.483 6.194 41.067 2.325 39.85 0h-.745c-1.231 2.325-3.648 6.21-7.66 9.976v.588c1.353.412 3.1 1.207 4.514 2.708 3.39 3.472.79 12.992-5.152 18.863-4.058 4.017-9.47 4.37-14.135.897-5.35-3.457-3.906-8.857-2.797-11.418l-.44-.426c-5.73.162-10.381-.736-12.95-1.398l-.486.5c.882 2.413 2.082 6.754 1.885 12.183l.44.427c4.894-1.898 8.436-.044 11.4 1.869C27.144 43.42 35.457 53.44 39.09 65.344h.745C43.468 53.44 51.782 43.42 65.202 34.769c2.964-1.913 6.52-3.767 11.399-1.87l.44-.426c-.197-5.414 1.004-9.77 1.885-12.183zM39.5 55.574c-3.42-6.49-7.295-10.756-13.131-16.465 7.386-1.721 11.474-8.357 13.131-13.257 1.657 4.9 5.745 11.536 13.132 13.257-5.837 5.709-9.712 9.99-13.132 16.465"
    ></path>
  </svg>
);

export default LogoIcon;
